declare const brand: unique symbol;

export type Brand<TValue, TBrand extends string> = TValue & { readonly [brand]: TBrand };

export type UserId = Brand<string, 'UserId'>;
export type TicketId = Brand<string, 'TicketId'>;
export type DepartmentId = Brand<string, 'DepartmentId'>;
export type ProjectId = Brand<string, 'ProjectId'>;
export type JobRoleId = Brand<string, 'JobRoleId'>;
export type CommentId = Brand<string, 'CommentId'>;
export type AttachmentId = Brand<string, 'AttachmentId'>;
export type RefreshTokenId = Brand<string, 'RefreshTokenId'>;
export type RefreshTokenFamilyId = Brand<string, 'RefreshTokenFamilyId'>;

export const userId = (value: string): UserId => value as UserId;
export const ticketId = (value: string): TicketId => value as TicketId;
export const departmentId = (value: string): DepartmentId => value as DepartmentId;
export const projectId = (value: string): ProjectId => value as ProjectId;
export const jobRoleId = (value: string): JobRoleId => value as JobRoleId;
export const commentId = (value: string): CommentId => value as CommentId;
export const attachmentId = (value: string): AttachmentId => value as AttachmentId;
export const refreshTokenId = (value: string): RefreshTokenId => value as RefreshTokenId;
export const refreshTokenFamilyId = (value: string): RefreshTokenFamilyId =>
  value as RefreshTokenFamilyId;
